import React, { createContext, useContext, useEffect, useState } from "react";
import {
  clearAuthSession,
  hasValidAuthSession,
} from "../../helper/authSession";
import { CallGETAPI } from "../../helper/Constants";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(hasValidAuthSession);

  useEffect(() => {
    const syncSession = () => {
      setLoggedIn(hasValidAuthSession());
    };

    syncSession();

    if (typeof window !== "undefined") {
      window.addEventListener("storage", syncSession);
      window.addEventListener("focus", syncSession);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("storage", syncSession);
        window.removeEventListener("focus", syncSession);
      }
    };
  }, []);

  useEffect(() => {
    if (!loggedIn) {
      return undefined;
    }

    let isMounted = true;

    const validateServerSession = async () => {
      if (!hasValidAuthSession()) {
        if (isMounted) {
          setLoggedIn(false);
        }
        return;
      }

      const response = await CallGETAPI("api/get-user-info");

      if (!response?.status && !hasValidAuthSession()) {
        if (isMounted) {
          setLoggedIn(false);
        }
        return;
      }

      if (isMounted) {
        setLoggedIn(hasValidAuthSession());
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        validateServerSession();
      }
    };

    validateServerSession();
    const intervalId = window.setInterval(() => {
      if (document.hidden) {
        return;
      }

      validateServerSession();
    }, 10000);

    window.addEventListener("focus", validateServerSession);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      isMounted = false;
      window.clearInterval(intervalId);
      window.removeEventListener("focus", validateServerSession);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [loggedIn]);

  const login = () => {
    setLoggedIn(true);
  };

  const logout = () => {
    clearAuthSession();
    setLoggedIn(false);
  };

  return (
    <AuthContext.Provider value={{ loggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

// export const ProtectedRoute = ({ element, ...rest }) => {
//   const { loggedIn } = useAuth();

//   return loggedIn ? (
//     <Route {...rest} element={element} />
//   ) : (
//     <Navigate to="/" replace />
//   );
// };
